import React from 'react';
import {
  Link
} from "react-router-dom";
import config from './../config.js';
import Aside from './common/aside.js';
import Loading from './../../components/loading.js';

import './../../style/image_result.css';


export default class ProjectImageDetail extends React.Component {

  constructor(props) {
    super(props);
    console.log(props);
    let user = {};

    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }
    const {
      projectid,
      taskid,
      type,
      result
    } = props.match.params;


    this.state = {
      page_title: '项目管理 ',
      page_subtitle: type.toUpperCase(),
      user: user,
      type: type,
      result: result,
      loading: true,
      projectid: projectid,
      taskid: taskid,
      taskname: '',
      project: '',
      creator: '',
      data: '',
      cor: '',
      sag: '',
      axi: '',
      corlength: '',
      saglength: '',
      axilength: '',
      corkey: '',
      sagkey: '',
      axikey: ''
    }
    document.title = this.state.page_title + this.state.page_subtitle;


    this.handleWheel = this.handleWheel.bind(this);

  }

  componentDidMount() {

    this.onInitial();
    this.getProject();

  }
  componentWillReceiveProps(nextProps) {
    const {
      projectid,
      taskid
    } = nextProps.match.params;

    this.setState({
      projectid: projectid,
      taskid: taskid,
    })
  }

  handleWheel(event) {
    event.preventDefault();
    //event.stopPropagation();
    const me = this;
    //console.log(event.currentTarget.id)
    const id = event.currentTarget.id;
    const data = me.state.data[id];
    const len = me.state[id + 'length'];
    let str = me.state[id + 'key'];
    //console.log(event.deltaY);

    if (event.deltaY > 0) {
      str -= 1;
    } else {
      str += 1;
    }

    str = str < 1 ? 1 : str;
    str = str >= len ? len - 1 : str;

    //console.log(str)

    me.setState({
      [id]: data[str],
      [id + 'key']: str
    });

  }

  onInitial() {
    const me = this;

    const {
      projectid,
      taskid,
      type,
      result
    } = me.state;

    const postdata = {
      userid: me.state.user.id,
      projectid: projectid,
      taskid: taskid,
      type: type,
      result: result,
      request: 'query',
      Authorization: localStorage.token
    }

    fetch(config.host + '/project_service/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => {
        me.setState({
          loading: false
        });
        return res.json();
      })
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          const data = json.data;
          //const size = json.size;
          for (let key in data) {
            //console.log(key); //axi or sag or cor
            //console.log(data[key]); // right values
            let str = parseInt((data[key].length - 1) / 2, 10);
            me.setState({
              [key]: data[key][str],
              [key + 'length']: data[key].length,
              [key + 'key']: str
            })
          }
          /*
                      for(let key in size){
                        me.setState({
                        [key]:size[key]
                       })
                      }
          */
          me.setState({
            taskname: json.task_name,
            data: data
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }


  getProject() {
    const me = this;

    let {
      projectid,
      user
    } = me.state;
    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid,
      Authorization: localStorage.token,
      request: 'project'
    };
    fetch(config.host + '/project/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          const data = json.data;
          me.setState({
            project: data.project,
            creator: data.creator
          });
        } else {
          me.notify(json.message);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }


  render() {

    return (
      <div className="row">
        <Loading display={this.state.loading} />
        <div className="col-10">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item "><Link className="text-dark " to={`/console/myprojects/project/service_list/${this.state.projectid}/${this.state.type}`}><strong><i className="fa fa-chevron-left"></i> 返回 {this.state.page_subtitle}列表</strong></Link>

                <small className="text-muted"> </small>
              </li>
              <li className="breadcrumb-item active">
                {this.state.project.name}
                [ 创建者: {this.state.creator.realname || this.state.creator.email || this.state.creator.title || this.state.creator.address || this.state.creator.office} ]
              </li>
              <li className="breadcrumb-item " aria-current="page">{this.state.page_subtitle}</li>
            </ol>
          </nav>

          <div className="row scoll-show">
            <div className="col-6 show-pic text-center align-middle" id="cor" onWheel={this.handleWheel}>
              <img src={this.state.cor} alt=""  />
                <span className="top">S</span>
                <span className="right">L</span>
                <span className="bottom">I</span>
                <span className="left">R</span>
            </div>
            <div className="col-6 show-pic text-center align-middle" id="sag" onWheel={this.handleWheel}>
              <img src={this.state.sag} alt="" />
                <span className="top">S</span>
                <span className="right">A</span>
                <span className="bottom">I</span>
                <span className="left">P</span>
            </div>
            <div className="col-6 show-pic text-center align-middle" id="axi" onWheel={this.handleWheel}>
              <img src={this.state.axi} alt="" />
                <span className="top">A</span>
                <span className="right">L</span>
                <span className="bottom">P</span>
                <span className="left">R</span>
            </div>
            <div className="col-6 show-pic text-center">
            </div>
          </div>

        </div>
        <div className="col-2  pl-0 pr-0">
          <Aside data={this.props.match.params} />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/apps/console/project_image_result.js